import React from 'react';
import {alpha} from '@mui/material/styles';
import {Body, Button, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './TrialBanner.module.scss';

type TrialBannerProps = {
  daysLeft: number;
  onStartSubscription: () => void;
  isCancelled: boolean;
};

function TrialBanner({
  daysLeft,
  onStartSubscription,
  isCancelled,
}: TrialBannerProps) {
  const backgroundColor = designSystemToken('semantic.bg.brand-secondary');
  const backgroundColorWithOpacity = alpha(backgroundColor, 0.3);

  return (
    <div
      className={styles.banner}
      style={{
        backgroundColor: backgroundColorWithOpacity,
      }}
    >
      <div className={styles.text}>
        <Body size="md">
          {translate('free-trial-end-period', {
            daysLeft,
          })}
        </Body>
      </div>
      <div className={styles.buttonContainer}>
        {isCancelled ? (
          <div className={styles.cancelledLabel}>{translate('Cancelled')}</div>
        ) : (
          <Button
            onClick={onStartSubscription}
            appearance="brand"
            mode="tinted"
            size="small"
          >
            {translate('Start Full Plan Now')}
          </Button>
        )}
      </div>
    </div>
  );
}

export default TrialBanner;
